import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { contractList, typeList, statusList, delContract } from './request';
import SuspensionModel from './suspensionModel.vue';
export default {
  components: {
    SuspensionModel
  },
  data() {
    return {
      suspensionShow: false,
      form: {},
      data: [],
      typeList: typeList,
      statusList: statusList,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [
        // {title: '序号',  dataIndex: 'index', key: '1',align: 'center' ,scopedSlots: {customRender: 'index'},width: 80},
        // {title: '归属客户',  dataIndex: 'customerName', key: '2',align: 'center'},
        // {title: '合同编号',  dataIndex: 'contractNo', key: '3',align: 'center'},
        // {title: '合作方',  dataIndex: 'partner', key: '4',align: 'center'},
        // {title: '合同类型',  dataIndex: 'typeName', key: '5',align: 'center'},
        // {title: '合同状态',  dataIndex: 'statusName', key: '6',align: 'center'},
        // {title: '录入时间',  dataIndex: 'createAt', key: '7',align: 'center',width: 200},
        // {title: '操作',scopedSlots: {customRender: 'action'},align: 'center',width: 330,key: '8'}
      ]
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    async getDataFun() {
      const h = this.$createElement;
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      const res = await contractList(obj);
      if (res.fieldConfig) {
        this.columns = res.fieldConfig.map(item => {
          let obj = item;
          obj.slots = {
            title: obj.title
          };
          obj.scopedSlots = {
            customRender: obj.dataIndex
          };
          delete obj.title;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          }
          return obj;
        });
        this.columns.push({
          slots: {
            title: '操作'
          },
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center',
          width: 330,
          key: '8'
        });
      }
      this.data = res.items;
      this.pagination.total = res.totalNum;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该合同') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delContract({
          contractId: val.contractId
        }).then(res => {
          _this.$message.success(_this.$t('操作成功') + '!');
          _this.getDataFun();
        });
      });
    },
    suspensionFun(val) {
      this.suspensionShow = true;
      this.$nextTick(() => {
        this.$refs.suspensionForm.init(val);
      });
    }
  }
};